import TeacherLoadContainer from "root/s360components/TeacherLoad/TeacherLoadContainer";
import React from "react";
import ReactAdminContainer from "root/s360components/Administration/ReactAdminContainer";

const TeacherLoadPage = ({}) =>
{
    return (
        <ReactAdminContainer>
            <TeacherLoadContainer />
        </ReactAdminContainer>
    )
}

export default TeacherLoadPage;